angular.module('invoice')
    .component('ksefConfigAssignment', {
        templateUrl: 'app/invoice/ksef/assignment.html',
        controller: function ($state, $stateParams, toastr, modals, KsefConfig, InvoiceAssignmentRule, KsefAssignmentRuleModalService, Principal, $filter) {
            this.ruleModes = ['FIXED', 'ROUND_ROBIN', 'LEAST_LOADED']
            this.ruleTypeOptions = [
                {value: 'ALL', label: 'Wszystkie'},
                {value: 'GLOBAL', label: 'Globalne'},
                {value: 'COMPANY', label: 'Dla spółki'}
            ]

            this.$onInit = () => {
                this.isAllRulesView = $state.current?.name === 'ksefAllAssignment'
                this.isGlobalRulesView = !this.isAllRulesView && !$stateParams.id
                this.ruleFilters = this.buildFiltersFromState()
                this.expanded = {groups: {}}
                this.availableBuyers = []
                this.rules = []
                this.page = {list: [], fullListSize: 0, sort: this.ruleFilters.sort}
                this.loadConfig()
                Principal.currentUser().then(() => {
                    this.canReadKSEF = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_KSEF_REGISTRY', 'ROLE_INVOICE_DOCUMENTS_KSEF_SETTINGS'])
                })
            }

            this.buildFiltersFromState = () => {
                let ruleType = ['GLOBAL', 'COMPANY'].includes($stateParams.filterRuleType) ? $stateParams.filterRuleType : 'ALL'
                let buyer = $stateParams.filterBuyerClientId != null && $stateParams.filterBuyerClientId !== ''
                    ? Number($stateParams.filterBuyerClientId)
                    : null
                let user = $stateParams.filterUserId != null && $stateParams.filterUserId !== ''
                    ? Number($stateParams.filterUserId)
                    : null
                return {
                    query: $stateParams.query || null,
                    buyer: this.isAllRulesView ? buyer : null,
                    user: user,
                    ruleType: this.isGlobalRulesView ? 'ALL' : ruleType,
                    sort: $stateParams.sort || null
                }
            }

            this.syncFiltersToState = () => {
                let params = angular.extend({}, $stateParams, {
                    query: this.ruleFilters?.query || null,
                    filterRuleType: !this.isGlobalRulesView && this.ruleFilters?.ruleType && this.ruleFilters.ruleType !== 'ALL'
                        ? this.ruleFilters.ruleType
                        : null,
                    filterBuyerClientId: this.isAllRulesView && this.ruleFilters?.buyer
                        ? this.ruleFilters.buyer
                        : null,
                    filterUserId: this.ruleFilters?.user || null,
                    sort: this.ruleFilters?.sort || null
                })
                $state.go($state.current, params, {notify: false, location: 'replace'})
            }

            this.loadConfig = () => {
                if (this.isGlobalRulesView || this.isAllRulesView) {
                    this.config = null
                    this.loadAvailableBuyers()
                    this.loadRules()
                    return
                }
                if (!$stateParams.id) {
                    return
                }
                KsefConfig.get({id: $stateParams.id}).$promise.then(result => {
                    this.config = result
                    this.loadRules()
                })
            }

            this.loadAvailableBuyers = () => {
                if (!this.isAllRulesView) {
                    this.availableBuyers = []
                    return
                }
                InvoiceAssignmentRule.list({includeAll: true}).$promise.then(items => {
                    let unique = {}
                    angular.forEach(items || [], item => {
                        let client = item?.buyer
                        if (!client?.id) {
                            return
                        }
                        if (!unique[client.id]) {
                            unique[client.id] = angular.copy(client)
                        }
                    })
                    this.availableBuyers = Object.keys(unique)
                        .map(key => unique[key])
                        .sort((a, b) => (a?.symbol || '').localeCompare(b?.symbol || ''))
                })
            }

            this.goBack = () => $state.go('ksefConfig')

            this.modeLabel = mode => {
                if (!mode) {
                    return '-'
                }
                return $filter('translate')('invoice.assignment.mode.' + mode)
            }

            this.modeClass = mode => {
                switch (mode) {
                    case 'FIXED': return 'label-default'
                    case 'ROUND_ROBIN': return 'label-warning'
                    case 'LEAST_LOADED': return 'label-success'
                    default: return 'label-default'
                }
            }

            this.remainingCount = (arr, limit) => {
                if (!arr || !arr.length) {
                    return 0
                }
                return Math.max(0, arr.length - limit)
            }

            this.openRuleModal = (rule, mode) => {
                if (!this.isGlobalRulesView && !this.isAllRulesView && !this.config?.client?.id) {
                    return
                }
                let payload = angular.copy(rule || null)
                if (mode === 'duplicate') {
                    payload = payload || {}
                    delete payload.id
                    delete payload.version
                    delete payload.audit
                    delete payload.createdBy
                    delete payload.createdTime
                    delete payload.updatedBy
                    delete payload.updatedTime
                    payload.buyer = {id: this.config.client.id}
                    payload.users = angular.copy(rule?.users || [])
                    payload.accessGroups = angular.copy(rule?.accessGroups || [])
                }
                return KsefAssignmentRuleModalService.open({
                    rule: payload,
                    mode: mode,
                    isGlobalRulesView: this.isGlobalRulesView,
                    isAllRulesView: this.isAllRulesView,
                    buyerId: this.config?.client?.id,
                    buyer: this.config?.client || payload?.buyer || null
                }).then(result => {
                    if (result === 'saved') {
                        this.loadRules()
                    }
                })
            }

            this.openRuleForm = () => this.openRuleModal(null, 'create')
            this.editRule = rule => {
                if (!this.canEditRule(rule)) {
                    return
                }
                return this.openRuleModal(rule, 'edit')
            }

            this.deleteRule = rule => {
                if (!this.canDeleteRule(rule)) {
                    return
                }
                let content = rule?.sellerNip || '#' + rule?.id
                return modals.confirmDelete(content, () => InvoiceAssignmentRule.delete({id: rule.id}).$promise.then(() => {
                    this.loadRules()
                }))
            }

            this.convertRuleToGlobal = rule => {
                if (!this.canConvertToGlobal(rule)) {
                    return
                }
                return modals.confirm('Czy na pewno zmienić regułę na globalną?', () => {
                    let payload = angular.copy(rule)
                    payload.buyer = null
                    payload.sourceType = payload.sourceType || 'KSEF'
                    payload.scope = payload.scope || 'GLOBAL'
                    return InvoiceAssignmentRule.update({id: rule.id}, payload).$promise.then(() => {
                        this.loadRules()
                        toastr.success('Reguła została zmieniona na globalną')
                    })
                })
            }

            this.duplicateGlobalRuleForCompany = rule => {
                if (!this.canDuplicateGlobalForCompany(rule)) {
                    return
                }
                return this.openRuleModal(rule, 'duplicate')
            }

            this.isGlobalRule = rule => !(rule?.buyer?.id)

            this.canEditRule = rule => {
                if (!rule) {
                    return false
                }
                if (this.isGlobalRulesView || this.isAllRulesView) {
                    return true
                }
                return !this.isGlobalRule(rule)
            }

            this.canDeleteRule = rule => {
                if (!rule) {
                    return false
                }
                if (this.isGlobalRulesView || this.isAllRulesView) {
                    return true
                }
                return !this.isGlobalRule(rule)
            }

            this.canConvertToGlobal = rule => {
                return !this.isGlobalRulesView && !this.isAllRulesView && !!rule?.id && !!rule?.buyer?.id
            }

            this.canDuplicateGlobalForCompany = rule => {
                return !this.isGlobalRulesView && !this.isAllRulesView && !!rule?.id && this.isGlobalRule(rule) && !!this.config?.client?.id
            }

            this.loadRules = () => {
                this.syncFiltersToState()
                let params = {}
                if (this.isAllRulesView) {
                    params.includeAll = true
                } else if (!this.isGlobalRulesView) {
                    let clientId = this.config?.client?.id
                    if (!clientId) {
                        this.rules = []
                        this.page = {list: [], fullListSize: 0, sort: this.ruleFilters.sort}
                        return
                    }
                    params.buyerClientId = clientId
                }
                if (this.ruleFilters?.query) {
                    params.query = this.ruleFilters.query
                    if (!this.isAllRulesView && this.isNumericQuery(this.ruleFilters.query)) {
                        params.sellerNip = this.ruleFilters.query
                    }
                }
                if (!this.isGlobalRulesView && this.ruleFilters?.ruleType && this.ruleFilters.ruleType !== 'ALL') {
                    params.filterRuleType = this.ruleFilters.ruleType
                }
                if (this.isAllRulesView && this.ruleFilters?.buyer) {
                    params.filterBuyerClientId = this.ruleFilters.buyer
                }
                if (this.ruleFilters?.user) {
                    params.filterUserId = this.ruleFilters.user
                }
                InvoiceAssignmentRule.list(params).$promise.then(items => {
                    this.rules = items || []
                    this.applySort()
                })
            }

            this.clearRuleFilter = () => {
                this.ruleFilters = {query: null, buyer: null, user: null, ruleType: 'ALL', sort: null}
                this.loadRules()
            }

            this.submitFilters = () => {
                this.loadRules()
            }

            this.isNumericQuery = q => {
                return (q || '').replace(/\D/g, '').length > 0
            }

            this.changeSort = column => {
                let current = this.parseSort()
                if (current.column === column) {
                    this.ruleFilters.sort = column + ',' + (current.desc ? 'asc' : 'desc')
                } else {
                    this.ruleFilters.sort = column + ',asc'
                }
                this.syncFiltersToState()
                this.applySort()
            }

            this.parseSort = () => {
                let sort = this.ruleFilters?.sort
                if (!sort) {
                    return {column: null, desc: false}
                }
                let parts = String(sort).split(',')
                return {
                    column: parts[0] || null,
                    desc: (parts[1] || 'asc').toLowerCase() === 'desc'
                }
            }

            this.sortIcon = column => {
                let current = this.parseSort()
                if (current.column !== column) {
                    return ''
                }
                return current.desc ? 'fa-sort-desc' : 'fa-sort-asc'
            }

            this.applySort = () => {
                let list = (this.rules || []).slice().sort((a, b) => this.compareRules(a, b))
                this.page = {
                    list: list,
                    fullListSize: list.length,
                    sort: this.ruleFilters.sort
                }
            }

            this.compareRules = (a, b) => {
                let current = this.parseSort()
                if (!current.column) {
                    return this.compareDefault(a, b)
                }
                let result = this.compareByColumn(a, b, current.column)
                if (result === 0) {
                    result = this.compareDefault(a, b)
                }
                return current.desc ? -result : result
            }

            this.compareDefault = (a, b) => {
                if (this.isAllRulesView) {
                    return this.compareChain([
                        [this.isNullGlobalFallback(a), this.isNullGlobalFallback(b)],
                        [this.sellerSortLabel(a), this.sellerSortLabel(b)],
                        [this.buyerSortLabel(a), this.buyerSortLabel(b)],
                        [this.assignmentPriorityForAllRulesView(a), this.assignmentPriorityForAllRulesView(b)],
                        [a?.sellerNip, b?.sellerNip],
                        [b?.id, a?.id]
                    ])
                }
                if (!this.isGlobalRulesView) {
                    let buyerClientId = this.config?.client?.id
                    return this.compareChain([
                        [this.assignmentPriorityForBuyer(a, buyerClientId), this.assignmentPriorityForBuyer(b, buyerClientId)],
                        [this.sellerSortLabel(a), this.sellerSortLabel(b)],
                        [a?.sellerNip, b?.sellerNip],
                        [b?.id, a?.id]
                    ])
                }
                return this.compareChain([
                    [this.isNullSellerNip(a), this.isNullSellerNip(b)],
                    [this.sellerSortLabel(a), this.sellerSortLabel(b)],
                    [a?.sellerNip, b?.sellerNip],
                    [b?.id, a?.id]
                ])
            }

            this.compareByColumn = (a, b, column) => {
                switch (column) {
                    case 'type':
                        return this.compareChain([
                            [this.ruleTypeLabel(a), this.ruleTypeLabel(b)]
                        ])
                    case 'buyer':
                        return this.compareChain([
                            [this.buyerSortLabel(a), this.buyerSortLabel(b)]
                        ])
                    case 'sellerNip':
                        return this.compareChain([
                            [a?.sellerNip, b?.sellerNip]
                        ])
                    case 'seller':
                        return this.compareChain([
                            [this.sellerSortLabel(a), this.sellerSortLabel(b)]
                        ])
                    case 'scope':
                        return this.compareChain([
                            [a?.scope, b?.scope]
                        ])
                    case 'assignMode':
                        return this.compareChain([
                            [a?.assignMode, b?.assignMode]
                        ])
                    case 'confidential':
                        return this.compareChain([
                            [a?.confidential ? 1 : 0, b?.confidential ? 1 : 0]
                        ])
                    case 'author':
                        return this.compareChain([
                            [a?.audit?.createdBy?.fullName || a?.audit?.createdBy?.login, b?.audit?.createdBy?.fullName || b?.audit?.createdBy?.login]
                        ])
                    case 'modified':
                        return this.compareChain([
                            [a?.audit?.updatedTime || a?.audit?.createdTime, b?.audit?.updatedTime || b?.audit?.createdTime]
                        ])
                    default:
                        return 0
                }
            }

            this.compareChain = pairs => {
                for (let pair of pairs) {
                    let result = this.compareValues(pair[0], pair[1])
                    if (result !== 0) {
                        return result
                    }
                }
                return 0
            }

            this.compareValues = (a, b) => {
                if (a == null && b == null) {
                    return 0
                }
                if (a == null) {
                    return 1
                }
                if (b == null) {
                    return -1
                }
                if (angular.isNumber(a) && angular.isNumber(b)) {
                    return a - b
                }
                return String(a).localeCompare(String(b), 'pl', {sensitivity: 'base'})
            }

            this.ruleTypeLabel = rule => {
                if (!rule?.sellerNip) {
                    return 'FALLBACK'
                }
                if (rule?.buyer?.id) {
                    return 'SPOLKA'
                }
                return 'GLOBALNA'
            }

            this.sellerSortLabel = rule => rule?.sellerClientSymbol || rule?.sellerClientName || null
            this.buyerSortLabel = rule => rule?.buyer?.symbol || rule?.buyer?.fullName || null
            this.isNullSellerNip = rule => !rule?.sellerNip
            this.isNullGlobalFallback = rule => !rule?.sellerNip && !rule?.buyer?.id

            this.assignmentPriorityForBuyer = (rule, buyerClientId) => {
                let buyerSpecific = !!rule?.buyer?.id && rule.buyer.id === buyerClientId
                let fallback = !rule?.sellerNip
                if (buyerSpecific && !fallback) {
                    return 0
                }
                if (!buyerSpecific && !fallback) {
                    return 1
                }
                if (buyerSpecific) {
                    return 2
                }
                return 3
            }

            this.assignmentPriorityForAllRulesView = rule => {
                let global = !rule?.buyer?.id
                let fallback = !rule?.sellerNip
                if (!fallback) {
                    return global ? 0 : 1
                }
                return global ? 3 : 2
            }

            this.onRuleFilterChanged = () => {
                this.loadRules()
            }

            this.toggleExpanded = (type, id) => {
                this.expanded[type][id] = !this.expanded[type][id]
            }

            this.isExpanded = (type, id) => {
                return !!this.expanded[type][id]
            }
        }
    })
